export enum ECurrency {
    UAH = "₴",
    EUR = "€",
    USD = "$"
}